import React, { FC, ReactNode, useMemo } from "react";
// 组件
import { MenuOutlined } from "@ant-design/icons";
// 方法
import { useSortable } from '@dnd-kit/sortable';
// 常量
import { CSS } from '@dnd-kit/utilities';
import { MoveTransferTableRowProps, SORT_DATAINDEX } from "../../../interface";

const MoveTransferTableRow: FC<MoveTransferTableRowProps> = props => {
  const { children, 'data-row-key': rowKey, index, ...restProps } = props;
  if (rowKey === undefined || index === undefined) return <tr {...restProps} children={children} />;
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: rowKey,
  });
  const rowChildren: ReactNode[] | null = useMemo(() => {
    if (!children) return null;
    const newChildren: ReactNode[] = [];
    if (Array.isArray(children) && children.length) {
      children.forEach(child => {
        if (child?.props?.dataIndex === SORT_DATAINDEX) {
          newChildren.push(React.cloneElement(child as React.ReactElement, {
            children: (
              <MenuOutlined
                ref={setActivatorNodeRef}
                style={{ touchAction: 'none', cursor: 'move' }}
                {...listeners}
              />
            ),
          }));
        } else {
          newChildren.push(child);
        }
      });
    }
    return newChildren;
  }, [children]);
  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Transform.toString(transform && { ...transform, scaleY: 1 }),
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  if (!rowChildren) return null;
  return (
    <tr {...restProps} data-row-key={rowKey} ref={setNodeRef} style={style} children={rowChildren} {...attributes} />
  );
};

export default MoveTransferTableRow;
